import './App.css';
import { Helmet } from 'react-helmet';
import InitialContainer from './components/initial/initialContainer';
import CVicon from './assets/CVicon.png';

function App() {
  return (
    <div className="App">
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="icon" href={CVicon} />
        <meta httpEquiv="Content-Security-Policy" content="upgrade-insecure-requests" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#0c111d" />
        <meta name="keywords" content="CV, portfolio, software developer, web development, React, TypeScript, Node.js, mobile development" />
        <meta
          name="description"
          content="Portfolio and resume of Arman Gharibyan, software developer focused on full-stack and mobile products."
        />
        <title>Arman Gharibyan | Software Developer</title>
      </Helmet>
      <InitialContainer />
    </div>
  );
}

export default App;
